import BaseApi from '@/api/base';

export const sendPasswordUpdateMail = () => {
  const body = {
    source: 'ChangePassword'
  };
  BaseApi.post('email', body, {});
}

export const formatPhoneNumber = (number: string) => {
  return number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
}
